<template>
  <div>
    <h5 class>Cliente</h5>
    <multiselect
      v-model="client"
      :options="clients"
      placeholder="Selecione um cliente "
      label="razao_social"
      track-by="id"
      :preserveSearch="true"
      :showNoResults="false"
      @input="notifyChange"
      :select-label="''"
      :deselect-label="''"
      :selected-label="'Selecionado'"
      @search-change="loadClients"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";



export default {
  name: "client-filter-select",
  components: {
    Multiselect,
  },
  props: ["client"],
  data() {
    return {
      clients: [],
      selectedClient: {},
    };
  },
  mounted() {
    this.loadClients();
    this.changeOptions();
    this.changeNameRouter();
  },
  methods: {
    loadClients(query) {
      var queryObj = null;
      if (typeof query != "undefined" && query != "") {
        queryObj = {
          razao_social: query,
        };
      }
      this.$http.secured
        .get("/api/v1/clients", {
          params: {
            q: queryObj,
          },
        })
        .then((response) => {
          this.clients = response.data["clients"]
            ? response.data["clients"]
            : [];
        });
    },
    notifyChange(client) {
      this.$emit("selected", client);
    },
    changeOptions() {
      this.$root.$on("options", (clientsRegion) => {
        this.clients = clientsRegion;
      });
    },
    changeNameRouter(){
      let client = this.$route.params.client;
      this.$emit("selected", client);
    },
  },
};
</script>
